module.exports = __webpack_public_path__ + "static/media/YM54_3.9c908cfc.jpg";